import { createSelector } from 'reselect';
import { SECTION_ACCESS_TYPES, VIEW_ONLY_SECTIONS } from '../utils/consts';

export const getNavigationState = state => state.navigation;

export const getNavigationSections = createSelector([getNavigationState], navigationState => navigationState.sections);

export const getElementAccessType = elementName =>
    createSelector([getNavigationSections], navigationSections => {
        const element = navigationSections
            .flatMap(section => section.elements)
            .find(({ name }) => name === elementName);
        const sections = element?.sections || [];
        return sections.some(({ access_type: accessType }) => accessType === SECTION_ACCESS_TYPES.EDIT)
            ? SECTION_ACCESS_TYPES.EDIT
            : SECTION_ACCESS_TYPES.VIEW;
    });

export const deriveSectionsAccess = sections => {
    const hasViewAccess = sections.some(
        ({ access_type: accessType, name }) =>
            accessType === SECTION_ACCESS_TYPES.VIEW && !VIEW_ONLY_SECTIONS.includes(name)
    );
    const hasEditAccess = sections.some(({ access_type: accessType }) => accessType === SECTION_ACCESS_TYPES.EDIT);
    const isSingleAccessLevel = (hasEditAccess && !hasViewAccess) || (hasViewAccess && !hasEditAccess);
    return {
        accessType: hasEditAccess ? SECTION_ACCESS_TYPES.EDIT : SECTION_ACCESS_TYPES.VIEW,
        isSingleAccessLevel,
    };
};
